import React from "react";

export default () => {
  return (
    <React.Fragment>
      <rect x="0" y="0" rx="3" ry="3" width="300" height="25" />

      <rect x="50" y="50" rx="3" ry="3" width="200" height="20" />
      <rect x="0" y="40" rx="3" ry="3" width="40" height="40" />
      <rect x="50" y="110" rx="3" ry="3" width="200" height="20" />
      <rect x="0" y="100" rx="3" ry="3" width="40" height="40" />
      <rect x="50" y="165" rx="3" ry="3" width="200" height="20" />
      <rect x="0" y="155" rx="3" ry="3" width="40" height="40" />
      <rect x="50" y="230" rx="3" ry="3" width="200" height="20" />
      <rect x="0" y="220" rx="3" ry="3" width="40" height="40" />

      <rect x="0" y="290" rx="3" ry="3" width="400" height="2" />
    </React.Fragment>
  );
};
